import selectBoxSelectionTagUrl from './selectBoxSelectionTag.html';

class SelectBoxSelectionTagCtrl {
  selectionFieldName = 'name'; // field name in selected object to be displayed in selected tag area

  $onChanges({ selectedItems }) {
    this.filteredItems = selectedItems.currentValue?.filter((item) => !item.deleted);
  }
}

export default {
  templateUrl: selectBoxSelectionTagUrl,
  controller: SelectBoxSelectionTagCtrl,
  controllerAs: 'ctrl',
  bindings: {
    selectedItems: '<',
    onRemove: '&',
    selectionFieldName: '@?',
  },
};
